import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { CardContent, CardDescription } from '@/components/ui/card';
import { Field, FieldLabel } from '@/components/ui/field';
import { FieldGroup, FieldDescription } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { useSignup } from '@/features/auth/auth-hooks';

const cn = (...classes: ClassValue[]) => twMerge(clsx(classes));

const RegisterForm = ({ className, ...props }: React.ComponentProps<'div'>) => {
  const { signupAsync, isSignupPending, isSignupSuccess, signupError } = useSignup();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    void (async () => {
      const form = new FormData(e.currentTarget);

      await signupAsync({
        username: form.get('name') as string,
        email: form.get('email') as string,
        password: form.get('password') as string,
        confirmPassword: form.get('confirmPassword') as string,
      });

      if (isSignupSuccess) window.location.href = '/';
    })();
  };

  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-semibold text-center">
            Crear cuenta
          </CardTitle>
          <CardDescription className="text-center">
            {/* Completa el formulario para registrarte */}
          </CardDescription>
        </CardHeader>

        <CardContent>
          <form onSubmit={onSubmit}>
            <FieldGroup>
              <Field>
                <FieldLabel htmlFor="name">Nombre</FieldLabel>
                <Input id="name" type="text" placeholder="Juan Pérez" required />
              </Field>

              <Field>
                <FieldLabel htmlFor="email">Correo electrónico</FieldLabel>
                <Input id="email" type="email" placeholder="mi@mail.com" required />
              </Field>

              <Field>
                <FieldLabel htmlFor="password">Contraseña</FieldLabel>
                <Input id="password" type="password" required />
              </Field>

              <Field>
                <FieldLabel htmlFor="confirmPassword">
                  Confirmar contraseña
                </FieldLabel>
                <Input id="confirmPassword" type="password" required />
              </Field>

              {signupError && (
                <FieldDescription className="text-center text-red-600">
                  {signupError.message}
                </FieldDescription>
              )}

              <Field>
                <Button type="submit" className="w-full" disabled={isSignupPending}>
                  {isSignupPending ? 'Registrando...' : 'Registrarse'}
                </Button>
                <FieldDescription className="text-center">
                  ¿Ya tienes cuenta? <a href="#">Inicia sesión</a>
                </FieldDescription>
              </Field>
            </FieldGroup>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default RegisterForm;
